import Product from './Product';

const getDesignOverviewConfig = () => ({
  url: '/mcp/custom-designs/overview',
});

export default class DesignType {
  static NAME = 'design_types';

  static LIST_PATH = ['designTypes'];

  static getListConfig = getDesignOverviewConfig;

  constructor(designType) {
    this.category = designType.name;
    this.categoryNr = designType.designCategories[0]
      .customDesigns[0].customProductCategory;
    this.subcategories = designType.designCategories.map((subcategory) => ({
      name: subcategory.name,
      subcategoryNr: subcategory.customDesigns[0].productCategoryFormat,
      designs: subcategory.customDesigns.map((customDesign) => new Product(customDesign))
    }));
  }
}
